export default __webpack_public_path__ + "static/media/marketplace-looksrare.ae7c52a5.png";